var _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShare(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon_share_ouline",
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_share_ouline_background",
    "data-name": "Icon_share_ouline background",
    d: "M0,0Z",
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_share_ouline-2",
    "data-name": "Icon_share_ouline",
    transform: "translate(2.196 1.647)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M7.412,10A1.611,1.611,0,0,1,5.85,8.639l-3.2-2.4a1.545,1.545,0,0,1-1.062.426A1.631,1.631,0,0,1,0,5,1.631,1.631,0,0,1,1.588,3.334a1.541,1.541,0,0,1,1.089.453l3.161-1.9a1.744,1.744,0,0,1-.014-.225A1.631,1.631,0,0,1,7.412,0,1.631,1.631,0,0,1,9,1.667,1.631,1.631,0,0,1,7.412,3.334,1.544,1.544,0,0,1,6.323,2.88l-3.16,1.9A1.849,1.849,0,0,1,3.177,5a1.806,1.806,0,0,1-.019.256L6.071,7.44a1.566,1.566,0,0,1,1.341-.773,1.669,1.669,0,0,1,0,3.333Zm0-2.222a.544.544,0,0,0-.53.551.029.029,0,0,1,0,.009.53.53,0,1,0,.53-.56ZM1.588,4.445a.556.556,0,0,0,0,1.111.556.556,0,0,0,0-1.111ZM7.412,1.111a.544.544,0,0,0-.53.556.53.53,0,1,0,1.059,0A.544.544,0,0,0,7.412,1.111Z",
    transform: "translate(-0.195 0.353)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.9ff3758a8d1a6f6120c411269d6b07a2.svg";
export { ForwardRef as ReactComponent };